var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRegisterCount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_35943_46465)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.494141,
    y: 0.5,
    width: 40,
    height: 40,
    rx: 10,
    fill: "#D5D5D5",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8205 28.8974L25.0769 28.8974C26.6347 28.8974 27.8975 27.6346 27.8975 26.0769L27.8975 15.8205C27.8975 14.2628 26.6347 13 25.0769 13L14.8205 13C13.2628 13 12 14.2628 12 15.8205L12 26.0769C12 27.6346 13.2628 28.8974 14.8205 28.8974ZM26.3588 26.0768C26.3588 26.7849 25.7848 27.3589 25.0767 27.3589L14.8203 27.3589C14.1122 27.3589 13.5383 26.7849 13.5383 26.0768L13.5383 15.8204C13.5383 15.1123 14.1122 14.5383 14.8203 14.5383L25.0767 14.5383C25.7848 14.5383 26.3588 15.1123 26.3588 15.8204L26.3588 26.0768Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.5,
    cy: 14.5,
    r: 5.5,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5 12V14.5M26.5 14.5V17M26.5 14.5H29M26.5 14.5H24",
    stroke: "#C4C4C4",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_35943_46465"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 40,
    height: 40,
    rx: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegisterCount);
export default __webpack_public_path__ + "static/media/register-count.92716d90dce2be10364386db58d89683.svg";
export { ForwardRef as ReactComponent };